export default __webpack_public_path__ + "static/media/Mass_04.f3508763.png";